module.exports = __webpack_public_path__ + "img/img-carousel2.45daf383.jpg";